import useAddressAutocomplete, {
    type Suggestion,
    type AddressDetails,
} from '../src/hooks/useAddressAutocomplete';

export default useAddressAutocomplete;

export type { Suggestion, AddressDetails };
